// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_2UgOkAlXvcsdCNji5IvZ9U","icon":"_1WIftSC4_IQPk0dpztAFhh","active":"_6aW4E3GzojI7l7Ee5eXh2"};